/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Metaofferstitle2Inputs */

const id_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran`)
};

const ms_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran`)
};

const da_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const de_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const en_us2_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const es_es2_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de catálogo`)
};

const es_mx2_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const fil_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer`)
};

const fr_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres`)
};

const it_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte`)
};

const hu_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok`)
};

const nl_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen`)
};

const no_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const pl_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty`)
};

const pt_br2_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de catálogo`)
};

const pt_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const ro_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte`)
};

const fi_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoukset`)
};

const sv_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudanden`)
};

const vi_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi`)
};

const tr_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler`)
};

const cs_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const bg_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферти`)
};

const ru_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения`)
};

const uk_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиції`)
};

const ar_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض`)
};

const hi_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र`)
};

const th_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ`)
};

const ja_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー`)
};

const zh_cn2_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项`)
};

const zh_hant1_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目`)
};

const ko_sandboxes_metaofferstitle2 = /** @type {(inputs: Sandboxes_Metaofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼`)
};

/**
* | output |
* | --- |
* | "Offers" |
*
* @param {Sandboxes_Metaofferstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_metaofferstitle2 = /** @type {((inputs?: Sandboxes_Metaofferstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Metaofferstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_metaofferstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_metaofferstitle2(inputs)
	if (locale === "da") return da_sandboxes_metaofferstitle2(inputs)
	if (locale === "de") return de_sandboxes_metaofferstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_metaofferstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_metaofferstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_metaofferstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_metaofferstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_metaofferstitle2(inputs)
	if (locale === "it") return it_sandboxes_metaofferstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_metaofferstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_metaofferstitle2(inputs)
	if (locale === "no") return no_sandboxes_metaofferstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_metaofferstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_metaofferstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_metaofferstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_metaofferstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_metaofferstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_metaofferstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_metaofferstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_metaofferstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_metaofferstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_metaofferstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_metaofferstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_metaofferstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_metaofferstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_metaofferstitle2(inputs)
	if (locale === "th") return th_sandboxes_metaofferstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_metaofferstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_metaofferstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_metaofferstitle2(inputs)
	return ko_sandboxes_metaofferstitle2(inputs)
});
export { sandboxes_metaofferstitle2 as "sandboxes.metaOffersTitle" }